import { mutate } from "swr";
import { apiUrls } from "./apiUtils";
import { fetcher } from "./fetcher";
import { API_ENDPOINTS } from "../constants/apiEndpoints";
import dayjs from "dayjs";
import urlcat from "urlcat";
import { calculateDateRange } from "./dateUtils";

/**
 * Prefetch critical data for authenticated users
 * This function prefetches wallets, categories, transactions, and statistics
 * to improve initial load performance
 */
export const prefetchAppData = () => {
  mutate(apiUrls.wallets(), fetcher(apiUrls.wallets()));
  
  mutate(API_ENDPOINTS.ALL_CATEGORIES, fetcher(API_ENDPOINTS.ALL_CATEGORIES));
  
  const currentMonth = dayjs();
  const monthStart = currentMonth.startOf('month').toDate();
  const monthEnd = currentMonth.endOf('month').toDate();
  const transactionsUrl = apiUrls.transactions({
    fromDate: monthStart.toISOString(),
    toDate: monthEnd.toISOString(),
  });
  mutate(transactionsUrl, fetcher(transactionsUrl));
  
  const currentDate = new Date();
  const dateRange = calculateDateRange(currentDate, 'monthly');
  const statisticsUrl = urlcat(apiUrls.statistics(), {
    from: dateRange.startDate.toISOString(),
    to: dateRange.endDate.toISOString(),
    cashType: 'expense',
    dateType: 'month',
  });
  mutate(statisticsUrl, fetcher(statisticsUrl));
};

